$(document).ready(function() {
    $('form.cancel-request').on('submit', function(e) {
        if(!confirm('Ben je zeker dat je de aanvraag wil annuleren?')) {
            e.preventDefault();
        }
    });
});
